import filter from 'lodash/filter';
import isEmpty from 'lodash/isEmpty';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import WidgetHeader from 'src/components/widgets/widget-header';
import { IAds } from 'src/modules/ads';
import { Category, Datum, SubCategory2 } from 'src/modules/cid';
import { DataContent } from 'src/modules/cid/id';
import { Data } from 'src/modules/sections/section-1';
import { DATALAYER_TYPE } from 'src/utils/datalayer/send-datalayer';
import { useMobilePhone } from 'src/utils/device';
import styled from 'styled-components';
import { KEY_ADS_POSITION } from '../ads/dynamicAds';
import WidgetBreadcrumb from '../widgets/widget-breadcrumb';
const DynamicAds = dynamic(import('../ads/dynamicAds'));
const CardOverlay = dynamic(import('src/components/cards/card-overlay'));
const CardV = dynamic(import('src/components/cards/card-v'));
const Carousels = dynamic(import('../carousels'));
const CardMainNews = dynamic(import('src/components/cards/card-main-news'));

type Props = {
  navBar: any;
  articles: any[];
  articlesHighlight: Data;
  acticlesresDataPin: DataContent;
  category: Category;
  subCategory: SubCategory2;
  subMenu: any;
  sliceId: number | any;
  listArticles: Datum[];
  isFetching?: boolean;
  ads?: IAds[];
};

const CategoryDefault = ({ articles, acticlesresDataPin, category, subCategory, subMenu, listArticles, sliceId, isFetching, ads }: Props) => {
  const router = useRouter();
  const filterSub = filter(subMenu?.sub, subMenu => !isEmpty(subMenu.data));
  return (
    <>
      <CategoryWrapper className='container'>
        {/* Heading */}
        {/* {router.query.cid === 'interview' && isEmpty(subCategory.th) && <WidgetSubcat data={subMenu} />} */}
        {/* Ads-PPN BILLBOARD */}
        {!isEmpty(ads) && <DynamicAds position={KEY_ADS_POSITION.BILLBOARD} data={ads} />}
        {isEmpty(router?.query?.sub) ? (
          <>
            <div className='breadcrumb-area'>
              <div className='breadcrumb-title'>
                <WidgetHeader as='h1' titleColor='#000000' title={category?.en ? category?.en : 'news'} variant='line' position='center' showViewMore={false} />
                {/* <h1 className='category m-0'>{category?.en ? category?.en : 'news'}</h1> */}

                {/* <h2 className='breadcrumb-h2'>{subCategory?.en ? subCategory?.en : category?.en}</h2> */}
              </div>
            </div>
            {!isEmpty(ads) && <DynamicAds position={KEY_ADS_POSITION.INARTICLE_1} data={ads} />}
            {!isEmpty(subMenu?.sub) && !isEmpty(filterSub) ? (
              <>
                <ul className='submenu-list' id='section-3'>
                  {subMenu?.sub?.map((item: any, i: any) => (
                    <li key={i}>
                      {!isEmpty(item.data.filter((itemSub: any) => (isEmpty(acticlesresDataPin) ? itemSub.id !== articles[0].id : itemSub?.id !== acticlesresDataPin?.id))) && (
                        <div className='title-left'>
                          <a href={`${item.link}`} title={item.nameEng}>
                            <h2 className={'active'}>{item?.nameEng}</h2>
                          </a>
                          <a href={`${item.link}`} title={item.nameEng}>
                            <p className={'active text-left'}>ดูทั้งหมด</p>
                          </a>
                        </div>
                      )}
                      {!isEmpty(item.data.filter((itemSub: any) => (isEmpty(acticlesresDataPin) ? itemSub.id !== articles[0].id : itemSub?.id !== acticlesresDataPin?.id))) && (
                        <div className='row category-list'>
                          {useMobilePhone() && (
                            <>
                              {i === 0 ? (
                                <>
                                  <CardOverlay
                                    data={item.data[0]}
                                    showTitle={true}
                                    showBlurb={false}
                                    showByline={false}
                                    showTime={false}
                                    external={false}
                                    //! DATALAYER
                                    eventDataLayer={{
                                      type: DATALAYER_TYPE.TRACK_INDEX,
                                      router: router?.pathname,
                                      section: 'section-2',
                                      data: {
                                        title: articles[0]?.title,
                                        heading: subCategory?.en ? `${category?.en}:${subCategory?.en}` : category?.en,
                                        index: 1
                                      }
                                    }}
                                  />
                                  <Carousels mobileSlideShowTwo={2} pauseOnHover={false} autoplaySpeed={6000} arrows={true}>
                                    {item.data
                                      .slice(1)
                                      .filter((itemSub: any) => (isEmpty(acticlesresDataPin) ? itemSub.id !== articles[0].id : itemSub?.id !== acticlesresDataPin?.id))
                                      .map((item: any, i: any) => (
                                        <div key={i} className='col-6 col-md-4 card-item'>
                                          <CardV
                                            data={item}
                                            showTitle={true}
                                            showBlurb={false}
                                            showByline={false}
                                            showTime={false}
                                            showCountview={false}
                                            external={false}
                                            //! DATALAYER
                                            eventDataLayer={{
                                              type: DATALAYER_TYPE.TRACK_INDEX,
                                              router: router?.pathname,
                                              section: 'section-3',
                                              data: {
                                                title: item?.title,
                                                heading: `${category?.en}:${subMenu?.sub[i]?.nameEng}`,
                                                index: i + 1
                                              }
                                            }}
                                          />
                                        </div>
                                      ))}
                                  </Carousels>
                                </>
                              ) : (
                                <Carousels mobileSlideShowTwo={2} pauseOnHover={false} autoplaySpeed={6000} arrows={true}>
                                  {item.data
                                    .filter((itemSub: any) => (isEmpty(acticlesresDataPin) ? itemSub.id !== articles[0].id : itemSub?.id !== acticlesresDataPin?.id))
                                    .map((item: any, i: any) => (
                                      <div key={i} className='col-6 col-md-4 card-item'>
                                        <CardV
                                          data={item}
                                          showTitle={true}
                                          showBlurb={false}
                                          showByline={false}
                                          showTime={false}
                                          showCountview={false}
                                          external={false}
                                          //! DATALAYER
                                          eventDataLayer={{
                                            type: DATALAYER_TYPE.TRACK_INDEX,
                                            router: router?.pathname,
                                            section: 'section-3',
                                            data: {
                                              title: item?.title,
                                              heading: `${category?.en}:${subMenu?.sub[i]?.nameEng}`,
                                              index: i + 1
                                            }
                                          }}
                                        />
                                      </div>
                                    ))}
                                </Carousels>
                              )}
                            </>
                          )}
                          {!useMobilePhone() && (
                            <>
                              {item.data.map((item: any, i: any) => (
                                <div key={i} className='col-6 col-md-4 card-item'>
                                  <CardV
                                    data={item}
                                    showTitle={true}
                                    showBlurb={false}
                                    showByline={false}
                                    showTime={false}
                                    showCountview={false}
                                    external={false}
                                    //! DATALAYER
                                    eventDataLayer={{
                                      type: DATALAYER_TYPE.TRACK_INDEX,
                                      router: router?.pathname,
                                      section: 'section-3',
                                      data: {
                                        title: item?.title,
                                        heading: `${category?.en}:${subMenu?.sub[i]?.nameEng}`,
                                        index: i + 1
                                      }
                                    }}
                                  />
                                </div>
                              ))}
                              <div className='border-bottom' />
                            </>
                          )}
                        </div>
                      )}
                    </li>
                  ))}
                </ul>
              </>
            ) : (
              <>
                {!isEmpty(listArticles) && (
                  <div className='card-list'>
                    <div className='row'>
                      {listArticles.slice(router.query.cid === 'latest-news' ? 0 : sliceId).map((item: any, i: any) => (
                        <div key={i} className='col-6 col-md-4 card-item'>
                          <CardV
                            data={item}
                            showTitle={true}
                            showBlurb={false}
                            showByline={false}
                            showTime={false}
                            showCountview={false}
                            external={false}
                            //! DATALAYER
                            eventDataLayer={{
                              type: DATALAYER_TYPE.TRACK_INDEX,
                              router: router?.pathname,
                              section: 'section-3',
                              data: {
                                title: item?.title,
                                heading: subCategory?.en ? `${category?.en}:${subCategory?.en}` : category?.en,
                                index: i + 1
                              }
                            }}
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                )}
                {isFetching && <div className='fetching'> กำลังโหลด... </div>}
              </>
            )}
          </>
        ) : (
          <>
            <div className='meta-data'>
              <h1 className='category m-0'>{subCategory?.en ? subCategory?.en : 'news'}</h1>
              <h2 className='category m-0'>{subCategory?.en ? subCategory?.en : 'news'}</h2>
            </div>
            {/* Heading */}
            <div className='breadcrumb-area'>
              <WidgetBreadcrumb data={{ category, subCategory }} isCate={true} />
            </div>
            <div className='card-sub'>
              {!isEmpty(articles) && (
                <>
                  <CardMainNews
                    data={articles[0]}
                    showTitle={true}
                    showBlurb={false}
                    //! DATALAYER
                    eventDataLayer={{
                      type: DATALAYER_TYPE.TRACK_INDEX,
                      router: router?.pathname,
                      section: 'section-2',
                      data: {
                        title: articles[0]?.title,
                        heading: subCategory?.en ? `${category?.en}:${subCategory?.en}` : category?.en,
                        index: 1
                      }
                    }}
                  />
                </>
              )}
            </div>
            {!isEmpty(listArticles) && (
              <div className='card-list'>
                <div className='row'>
                  {listArticles.slice(sliceId).map((item: any, i: any) => (
                    <div key={i} className='col-6 col-md-4 card-item'>
                      <CardV
                        data={item}
                        showTitle={true}
                        showBlurb={false}
                        showByline={false}
                        showTime={false}
                        showCountview={false}
                        external={false}
                        //! DATALAYER
                        eventDataLayer={{
                          type: DATALAYER_TYPE.TRACK_INDEX,
                          router: router?.pathname,
                          section: 'section-3',
                          data: {
                            title: item?.title,
                            heading: subCategory?.en ? `${category?.en}:${subCategory?.en}` : category?.en,
                            index: i + 1
                          }
                        }}
                      />
                    </div>
                  ))}
                </div>
              </div>
            )}
            {isFetching && <div className='fetching'> กำลังโหลด... </div>}
          </>
        )}
        {/* {!isEmpty(subMenu?.sub) && (
          <>
            <ul className='submenu-list'>
              {subMenu?.sub?.map((item: any, i: any) => (
                <li key={i}>
                  <a
                    href={`${item.link}`}
                    //! DATALAYER
                    onClick={() =>
                      sendDataLayerGlobal({
                        type: DATALAYER_TYPE.TRACK_INDEX,
                        router: router?.pathname,
                        section: 'section-2',
                        data: {
                          title: item?.nameTh,
                          heading: `${category?.en}:${item?.nameTh}`,
                          index: i + 2
                        }
                      })
                    }>
                    <p
                      className={`${
                        router?.query?.sub === item?.nameTh ? '--active' : ''
                      }`}>
                      {item?.nameTh}
                    </p>
                  </a>
                </li>
              ))}
            </ul>

            <div className='border-bottom' />
          </>
        )} */}
        {/* Heading */}
        {/* <div className='row' id='section-2'>
          --------------------------------- CONTENT LISTS --------------------------------
          {!isEmpty(listArticles) && (
            <div className='col-12 card-v-category'>
              <h2 className='d-none'>{subCategory?.en ? subCategory?.en : category?.en}</h2>
              <div className='row'>
                {listArticles.slice(sliceId).map((item, index) => (
                  <div key={index} className='card-v-category-item'>
                    <CardV
                      data={item}
                      showTitle={true}
                      showBlurb={false}
                      showByline={false}
                      showTime={false}
                      showCountview={false}
                      external={false}
                      //! DATALAYER
                      eventDataLayer={{
                        type: DATALAYER_TYPE.TRACK_INDEX,
                        router: router?.pathname,
                        section: 'section-3',
                        data: {
                          title: item?.title,
                          heading: subCategory?.en ? `${category?.en}:${subCategory?.en}` : category?.en,
                          index: index + 1
                        }
                      }}
                    />
                  </div>
                ))}
              </div>
            </div>
          )}
        </div> */}
        {/* {isFetching && <div className='fetching'> กำลังโหลด... </div>} */}
      </CategoryWrapper>
    </>
  );
};

const CategoryWrapper = styled.div`
  overflow-x: hidden;
  .card-sub {
    margin-bottom: 15px;
  }
  .meta-data {
    display: none;
  }
  .card-list {
    .card-item {
      padding: 0 5px 10px 5px;
    }
  }
  .submenu-nav {
    margin-top: 20px;
    min-height: 121px;
    @media (max-width: 768px) {
      min-height: 85px;
    }
    @media (max-width: 475px) {
      min-height: 70px;
    }
    .submenu-nav-list {
      list-style-type: none;
      display: flex;
      flex-wrap: wrap;
      padding: 0;
      margin: 0;
      width: 100%;
      text-align: center;
      li {
        width: 20%;
        max-width: 100%;
        @media (max-width: 480px) {
          width: unset;
          max-width: unset;
          padding: 0 10px;
        }
        p {
          width: fit-content;
          font-size: 24px;
          text-transform: uppercase;
          font-weight: 400;
          color: #b3b3b3;
          padding: 10px 0 2px 0;
          margin: auto;
          border-bottom: 2px solid transparent;
          @media (max-width: 768px) {
            font-size: 18px;
          }
          @media (max-width: 480px) {
            font-size: 12px;
          }
          &:hover {
            border-bottom: 2px solid #ed1a3b;
            color: #000 !important;
          }
          &.--active {
            border-bottom: 2px solid #ed1a3b;
            color: #000 !important;
          }
        }
      }
    }
    .border-bottom {
      margin-top: 30px;
      margin-right: 15px;
      margin-left: 15px;
      @media (max-width: 1024px) {
        margin-top: 10px;
        margin-right: unset;
        margin-left: unset;
      }
    }
    @media (max-width: 480px) {
      margin-top: -20px;
    }
  }
  .title-left {
    display: flex;
    align-items: center;
    justify-content: space-between;
    @media (max-width: 768px) {
      margin-top: 12px;
    }
    a {
      transition: all 0.4s ease-in-out;
      &:hover {
        color: #ed1a3b;
      }
    }
    h2 {
      text-transform: uppercase;
      font-size: 30px;
      font-weight: bold;
      @media (max-width: 768px) {
        font-size: 24px;
      }
    }
    .text-left {
      font-size: 16px;
      padding: 2px 10px;
      background-color: rgb(220 21 53);
      color: #fff;
      border-radius: 8px;
      white-space: nowrap;
      &:hover {
        color: #ed1a3b;
        background-color: rgb(255, 255, 255);
      }
    }
  }
  .fetching {
    color: #fff;
  }
  h2 {
    color: black;
    font-size: 20px;
    font-weight: 400;
  }
  .submenu-list {
    padding: 0;
    margin: 0;
    width: 100%;
    list-style: none;
    .slick-slider {
      margin: 0 -10px;
      .slick-prev {
        z-index: 1;
        left: 10px;
      }
      .slick-next {
        z-index: 1;
        right: 19px;
      }
    }
    .card-item {
      padding: 0 5px 10px 5px;
    }
    li {
      &:last-child {
        .border-bottom {
          border-bottom: 1px solid transparent;
        }
      }
      p {
        width: fit-content;
        font-size: 24px;
        text-transform: uppercase;
        font-weight: 400;
        color: #fff;
        padding: 10px 0 2px 0;
        @media (max-width: 768px) {
          font-size: 18px;
        }
        @media (max-width: 480px) {
          font-size: 12px;
        }
      }
    }
    .category-list {
      margin: 10px -10px 0px -10px;
      @media (max-width: 480px) {
        margin: 0;
      }
      .card-item {
        .card-v {
          .--content {
            h3 {
              font-size: 16px;
            }
          }
        }
      }
    }
  }
  .breadcrumb-area {
    text-align: center;
    padding: 0 0 30px 0;
    @media (max-width: 690px) {
      padding: 20px 0;
    }
    #widget-breadcrumb {
      margin: 30px 0 -20px 0;
    }
    .breadcrumb-h2 {
      display: none;
    }
    .category {
      text-transform: uppercase;
      font-weight: bold;
      font-size: 80px;
      border-bottom: 2px solid black;
      @media (max-width: 768px) {
        font-size: 48px;
      }
    }
  }
  /* .submenu-list {
  list-style-type: none;
  display: flex;
  flex-wrap: wrap;
  padding: 0;
  margin: 0;
  width: 100%;
  text-align: center; 
  li {   
    width: 20%;
    max-width: 100%;
    @media (max-width:480px) {
      width: unset;
      max-width: unset;
      padding: 0 10px;
    }
    p {
      width: fit-content;
      font-size: 24px;
      text-transform: uppercase;
      font-weight: 400;
      color: #B3B3B3;
      padding: 10px 0 2px 0;
      margin: auto;
      border-bottom: 2px solid transparent;
      @media (max-width: 768px) {
        font-size: 18px;
      }
      @media (max-width: 480px) {
        font-size: 12px;
      }
      &:hover {
        border-bottom: 2px solid #ed1a3b;
        color: #000 !important;
      }
      &.--active {
        border-bottom: 2px solid #ed1a3b;
        color: #000 !important;
      }
    }
  }
} */
  /* .crad-overlay-category-item {
    margin: 30px 0;
  }

  .card-v-category {
    padding-left: 0;
    padding-right: 0;
    text-transform: uppercase;
    .d-none {
      display: none;
    }
    h2 {
      padding: 0 10px;
    }

    .card-v-category-item {
      padding: 0 10px;
      .card-v {
        .--content {
          h3 {
            font-size: 16px;
          }
        }
      }
      @media (max-width: 480px) {
        width: 50% !important;
      }
      &:nth-child(1),
      :nth-child(2) {
        width: 50%;
      }
      &:not(:nth-child(1), :nth-child(2)) {
        width: 33.333%;
      }
    }
  } */

  .border-bottom {
    margin: 12px 0;
    border-bottom: 1px solid #5f5f5f42;
  }

  .card-main-news {
    border-radius: 0px;
    .title {
      font-size: 22px;
    }
    .category {
      font-size: 16px;
    }
  }
`;

export default CategoryDefault;
